
import { Link } from "react-router-dom";
import AkkhorLayout from "../../layout/AkkhorLayout";
import List from "../../component/List";

export default function ListTransactions() {
    let params = '';
    const columns = [
        { name: "id", label: "ID" },
        {
            name: "customers", label: "Thông tin khách hàng",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if (value) {
                        return value.map((item) => <div className="w-100 p-2 mb-1 rounded bg-white border">
                            <div className="w-100 flex">
                                <span>Họ tên: </span>
                                <strong>{item.fullname}</strong>
                            </div>
                            <div className="w-100 flex">
                                <span>Số điện thoại: </span>
                                <strong>{item.mobile}</strong>
                            </div>
                        </div>)
                    }
                    return null
                },
            }
        },
        {
            name: "product_id", label: "Thông tin sản phẩm",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {

                    return <div>
                        <div className="w-100 flex">
                            <span>Tên sản phẩm: </span>
                            <strong>{tableMeta.banghang_title}</strong>
                        </div>
                        <div className="w-100 flex">
                            <span>Dự án: </span>
                            <strong>{tableMeta.duan_title}</strong>
                        </div>
                    </div>
                },
            }
        },
        {
            name: "status", label: "Trạng thái",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if (value == 1) return "Hoạt động"
                    if (value == 0) return "Ngừng hoạt động"
                    return null
                },
            }
        },
        { name: "author_name", label: "Người tạo" },
        { name: "datecreate", label: "Ngày thêm", }
    ];

    return (<AkkhorLayout idrole="giao-dich">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Quản lý giao dịch
                </li>
            </ul>
        </div>
        <List name="transactions" idrole="giao-dich" params={params} title="" defaultLimit={50} serverSide={true} columns={columns}></List>
    </AkkhorLayout>);
}
